/** @jsxImportSource @emotion/react */

import { createElement } from "react";

import { icons } from "./icons.js";

import { css } from "./css";

const Icon = ({
  icon,
  isOpen,
  fill = null,
  stroke = null,
  ...rest
}) => (
  <div className="icon" css={css(fill, stroke, isOpen)} {...rest}>{createElement(icons[icon])}</div>
);

export default Icon;
